import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ProfileEditorDrawerOutsideWorkWrapper = styled.div`
  padding: 183px 36px 0px 36px;

  & textarea {
    min-height: 272px;
  }

  ${BREAKPOINTS.tablet} {
    padding: 45px 16px;
  }
`;
